import "./layout";
import "./view";
import "./text";
import "./textCurrency";
import "./textField";
import "./button";
import "./image";
import "./inputCheck";
import "./inputImage";
import "./imageSelector";
import "./inputDate";
import "./inputSelect";
import "./inputSwitch";
import "./inputSuggest";
import "./selectItem";
import "./radioOption";
import "./loading";
import "./slider";
import "./modal";
import "./enfatize";
import "./softSwitcher";

export default {};
